import React from 'react'

/**
 * 显示本页链接
 * @todo 通过扫描二维码方式，将当前页面及session信息转移到新设备，并同时冻结原设备操作
 */
export default class SelfLink extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      location: window.location.href, 
      date: new Date()
    }
  }

  componentDidMount() {

  }

  componentWillUnmount() {
  }

  render() {
    return (
      <div>
        <a href={this.state.location}>打开一个新页面</a>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./usr/lib/ui/src/components/SelfLink.js